import './Returns.scss';
import 'babel-polyfill';
import React, { useState } from 'react';
import FindOrder from './ReturnFindOrder.jsx';
import OrderDetails from './ReturnOrderDetails.jsx';
import config from '../../config';

const Finish = () => {
  return (
    <div>
      <h1>We've received your application</h1>
      <p>Thank you. Our Customer Service Team will be in touch to advise next steps.</p>
    </div>
  );
}

const Returns = () => {
  const [orderer, setOrderer] = useState(null);
  const [order, setOrder] = useState(null);
  const [itemsToReturn, setItemsToReturn] = useState(null);

  const handleSetOrder = order => {
    setOrder(order);
  }

  const handleSetOrderer = orderer => {
    setOrderer(orderer);
  }

  const handleSubmit = async items => {
    setItemsToReturn(items);

    // Strip out everything except the details surrounding the return
    // Otherwise it tries to post all of the possible variants and
    // product information, resulting in a 413 api response on
    // some products.

    const reducedItems = order.line_items.reduce((acc, curr) => {
      if (items[curr.variant_id]) { // if it's not being returned, just skip it
        return [
          ...acc,
          {
            id: curr.id,
            product_id: curr.product_id,
            variant_id: curr.variant_id,
            name: curr.title,
            exchangeSize: items[curr.variant_id].exchangeSize,
            price: curr.price,
            type: items[curr.variant_id].type,
            reason: items[curr.variant_id].reason,
            quantity: items[curr.variant_id].quantity,
          },
        ]
      }

      return acc;
    }, []);

    const data = {
      customerEmail: orderer.email,
      orderId: orderer.orderNumber,
      items: reducedItems
    }

    await fetch(`${config.backendUrl}/shopify-store/${config.storeId}/returns`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });

    return;
  }

  return (
    <div className="returns-holder">
      <div className="returns">
        {!order && <FindOrder handleSetOrder={handleSetOrder} handleSetOrderer={handleSetOrderer} />}
        {(order && !itemsToReturn) && <OrderDetails onOrder={handleSetOrder} order={order} onSubmit={handleSubmit} />}
        {itemsToReturn && <Finish />}
      </div>
    </div>
  );
};

export default Returns;